// Simple email test without dynamic imports
import emailjs from '@emailjs/browser';

// Simple test function
export async function simpleEmailTest(testEmail) {
  try {
    console.log('🧪 Starting simple email test...');
    console.log('📧 EmailJS object:', emailjs);
    console.log('📧 EmailJS methods:', Object.keys(emailjs || {}));
    
    // Check environment variables
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    
    console.log('📧 Environment check:');
    console.log('- Service ID:', serviceId);
    console.log('- Template ID:', templateId);
    console.log('- Public Key:', publicKey ? 'Set' : 'Missing');
    
    if (!serviceId || !templateId || !publicKey) {
      throw new Error('Missing EmailJS configuration');
    }
    
    if (!emailjs) {
      throw new Error('EmailJS not loaded');
    }
    
    // Initialize EmailJS
    console.log('📧 Initializing EmailJS...');
    emailjs.init(publicKey);
    
    // Using the working Simple Format: name, email, subject, message
    const testParams = {
      name: 'Test User',
      email: testEmail,
      subject: 'Booking Confirmation - TEST123',
      message: `Dear Test User,

Thank you for choosing Skyline Backpackers! Your booking has been confirmed.

📋 Booking Details:
• Booking ID: TEST123
• Check-in: Aug 26, 2025
• Check-out: Aug 28, 2025
• Duration: 2 nights
• Beds: 1
• Total Amount: ₹1258
• Payment Status: ✅ Paid (Online Payment)

📍 Location: Sindhi Colony, Hyderabad
📞 Contact: +91 90327 97797

Thank you for choosing Skyline Backpackers!`
    };
    
    console.log('📧 Sending email with params:', testParams);
    
    // Send email
    const response = await emailjs.send(serviceId, templateId, testParams);
    
    console.log('✅ Email sent successfully:', response);
    return {
      success: true,
      response: response,
      message: 'Email sent successfully!'
    };
    
  } catch (error) {
    console.error('❌ Email test failed:', error);
    console.error('❌ Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack
    });
    
    return {
      success: false,
      error: error.message,
      details: error
    };
  }
}
